import ChannelLevel from "../Enum/ChannelLevel";

export default interface PermissionChannel {
    channelName: string,
    channelPath: string,
    permissionPolicyEditor: string,
    level: ChannelLevel,
    routerMethod: RouterMethod,
}

export enum RouterMethod {
    Browser = "Browser",
    Hash = "Hash",
    Link = "Link",
}
